import { render, staticRenderFns } from "./_language.vue?vue&type=template&id=dc1709ac&scoped=true&"
import script from "./_language.vue?vue&type=script&lang=js&"
export * from "./_language.vue?vue&type=script&lang=js&"
import style0 from "./_language.vue?vue&type=style&index=0&id=dc1709ac&prod&scoped=true&lang=css&"
import style1 from "./_language.vue?vue&type=style&index=1&id=dc1709ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1709ac",
  null
  
)

export default component.exports